import { render, staticRenderFns } from "./ViqFeedback.vue?vue&type=template&id=5438b872&scoped=true"
import script from "./ViqFeedback.vue?vue&type=script&lang=js"
export * from "./ViqFeedback.vue?vue&type=script&lang=js"
import style0 from "./ViqFeedback.vue?vue&type=style&index=0&id=5438b872&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5438b872",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5438b872')) {
      api.createRecord('5438b872', component.options)
    } else {
      api.reload('5438b872', component.options)
    }
    module.hot.accept("./ViqFeedback.vue?vue&type=template&id=5438b872&scoped=true", function () {
      api.rerender('5438b872', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/viq/ViqFeedback.vue"
export default component.exports